// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_chatLeft__3i6kB {
  width: 350px;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #dce1e6;
  position: relative;
}
@media (max-width: 991.98px) {
  .style_chatLeft__3i6kB {
    width: 100%;
  }
}
.style_chatLeft__3i6kB .style_btnInvite__Z8Jnh {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  height: 54px;
  width: 54px;
  border-radius: 54px;
  cursor: pointer;
  right: 1.2rem;
  bottom: 1.2rem;
  z-index: 3;
  background-color: #5f8fdf;
  transition: all 0.25s;
  border: 3px solid white;
}
.style_chatLeft__3i6kB .style_btnInvite__Z8Jnh svg {
  height: 24px;
  width: 24px;
  color: white;
}
.style_chatLeft__3i6kB .style_btnInvite__Z8Jnh:hover {
  border: 3px solid #cce4ff;
}
@media (max-width: 991.98px) {
  .style_chatLeft__3i6kB.style_chatLeftHide__hZtyQ {
    visibility: hidden;
    transform: translateX(-100%);
  }
}

.style_headerContacts__cczrO {
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  padding-top: 18px;
  gap: 8px;
  text-align: start;
}
.style_headerContacts__cczrO .style_titleHeader__yXO5n {
  font-size: 20px;
  line-height: 26px;
  font-weight: 700;
  color: #4a596a;
}
.style_headerContacts__cczrO .style_wrapperTabs__nMQhy {
  width: 100%;
  display: inline-flex;
  flex-direction: row;
}
.style_headerContacts__cczrO .style_wrapperTabs__nMQhy .style_tabItem__zeqnp {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  width: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  cursor: pointer;
  border-bottom: 2px solid #e9e9eb;
  overflow: hidden;
  text-overflow: ellipsis;
}
.style_headerContacts__cczrO .style_wrapperTabs__nMQhy .style_tabItem__zeqnp .style_unreadCount__NhwlO {
  margin-inline-start: 5px;
  transition: background-color 0.2s ease-in-out;
  border-radius: 16px;
  color: #ffffff;
  background-color: #5f8fdf;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  padding: 0 7px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 22px;
}
.style_headerContacts__cczrO .style_wrapperTabs__nMQhy .style_tabItem__zeqnp.style_active__ORA8B {
  color: #5f8fdf;
  cursor: pointer;
  border-bottom: 2px solid #5f8fdf;
}

.style_msg-new-tab__2pIVl {
  font-size: medium;
  font-weight: 500;
  width: 50%;
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  padding-bottom: 4px;
  border-radius: 15px;
  padding-top: 5px;
  background: #ffffff;
  color: #000000;
}

.style_msg-withdraw-tab__hbFaP {
  border-radius: 15px;
  padding-top: 5px;
  background: #ffffff;
  color: #000000;
  font-size: medium;
  font-weight: 500;
  width: 50%;
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  padding-bottom: 4px;
}

.style_msg-tab-active__n6kF2 {
  font-size: medium;
  font-weight: 500;
  width: 50%;
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  padding-bottom: 4px;
  background-color: lightgray;
  color: #000000;
}

.style_msg-tabs-cont__w-2St {
  width: 100%;
  display: inline-flex;
  flex-direction: row;
  margin-top: 5px;
  margin-bottom: 5px;
  padding-left: 3px;
  padding-right: 3px;
}

.style_btnClose__W6JFD {
  background: transparent;
  border: none;
  padding: 0;
}
.style_btnClose__W6JFD svg {
  fill: #909399;
}

.style_modalDialog__JNBfm {
  width: 328px;
}
@media (max-width: 576px) {
  .style_modalDialog__JNBfm {
    width: auto;
  }
}
.style_modalDialog__JNBfm .style_modalHeader__HUca5 {
  justify-content: space-between;
  border: none;
}
.style_modalDialog__JNBfm .style_modalBody__2vIH0 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;
}
.style_modalDialog__JNBfm .style_modalBody__2vIH0 .style_inputBox__Lf\\+UU {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.style_modalDialog__JNBfm .style_modalBody__2vIH0 .style_inputBox__Lf\\+UU .style_headerInput__0tucd {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.style_modalDialog__JNBfm .style_modalBody__2vIH0 .style_inputBox__Lf\\+UU .style_headerInput__0tucd span {
  font-size: 14px;
  line-height: 18px;
  color: #4a596a;
}
.style_modalDialog__JNBfm .style_modalBody__2vIH0 .style_inputBox__Lf\\+UU .style_headerInput__0tucd .style_counter__hXANB {
  font-size: 12px;
  color: #495057;
}
.style_modalDialog__JNBfm .style_modalBody__2vIH0 .style_inputBox__Lf\\+UU .style_error__9bcnW {
  color: #ec205f;
  font-size: 12px;
}
.style_modalDialog__JNBfm .style_modalFooter__b2nM5 {
  border: none;
}
.style_modalDialog__JNBfm .style_modalFooter__b2nM5 .style_dlgBtns__mM\\+KV {
  width: 100%;
  display: flex;
  gap: 16px;
}
.style_modalDialog__JNBfm .style_modalFooter__b2nM5 .style_dlgBtns__mM\\+KV button {
  width: 100%;
}

.style_boxLoader__ePIkg {
  padding-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.style_loader__hk9yk {
  width: 88px;
  height: 12px;
  background: radial-gradient(circle 5px at 5px center, #5f8fdf 100%, transparent 0), radial-gradient(circle 5px at 5px center, #5f8fdf 100%, transparent 0);
  background-size: 12px 12px;
  background-repeat: no-repeat;
  position: relative;
  animation: style_ballX__ZsvzQ 1s linear infinite;
}

.style_loader__hk9yk:before {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #5f8fdf;
  inset: 0;
  margin: auto;
  animation: style_moveX__KWjbp 1s cubic-bezier(0.5, 300, 0.5, -300) infinite;
}

@keyframes style_ballX__ZsvzQ {
  0%, 25%, 50%, 75%, 100% {
    background-position: 25% 0, 75% 0;
  }
  40% {
    background-position: 25% 0, 85% 0;
  }
  90% {
    background-position: 15% 0, 75% 0;
  }
}
@keyframes style_moveX__KWjbp {
  100% {
    transform: translate(0.15px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Contacts/style.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,kBAAA;AADF;AAGE;EARF;IASI,WAAA;EAAF;AACF;AAEE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,yBCrBW;EDsBX,qBAAA;EACA,uBAAA;AAAJ;AAEI;EACE,YAAA;EACA,WAAA;EACA,YAAA;AAAN;AAGI;EACE,yBAAA;AADN;AAOI;EAFF;IAGI,kBAAA;IACA,4BAAA;EAJJ;AACF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,QAAA;EACA,iBAAA;AALF;AAOE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cCpDa;AD+CjB;AAQE;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;AANJ;AAQI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,uBAAA;AANN;AAQM;EACE,wBAAA;EACA,6CAAA;EACA,mBAAA;EACA,cC1FA;ED2FA,yBCpFO;EDqFP,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AANR;AASM;EACE,cC/FO;EDgGP,eAAA;EACA,gCAAA;AAPR;;AAqBA;EACE,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EAEA,mBAAA;EACA,gBAAA;EACA,mBCjIM;EDkIN,cCjIM;AD8GR;;AAsBA;EACE,mBAAA;EACA,gBAAA;EACA,mBCxIM;EDyIN,cCxIM;ED0IN,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,cC5JM;ADwIR;;AAuBA;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,uBAAA;EACA,YAAA;EACA,UAAA;AApBF;AAsBE;EACE,aClKa;AD8IjB;;AAwBA;EACE,YAAA;AArBF;AAuBE;EAHF;IAII,WAAA;EApBF;AACF;AAsBE;EACE,8BAAA;EACA,YAAA;AApBJ;AAuBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AArBJ;AAuBI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AArBN;AAuBM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AArBR;AAuBQ;EACE,eAAA;EACA,iBAAA;EACA,cCxMO;ADmLjB;AAwBQ;EACE,eAAA;EACA,cAAA;AAtBV;AA0BM;EACE,cAAA;EACA,eAAA;AAxBR;AA6BE;EACE,YAAA;AA3BJ;AA6BI;EACE,WAAA;EACA,aAAA;EACA,SAAA;AA3BN;AA6BM;EACE,WAAA;AA3BR;;AAiCA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA9BF;;AAiCA;EACE,WAAA;EACA,YAAA;EACA,0JAAA;EAEA,0BAAA;EACA,4BAAA;EACA,kBAAA;EACA,gDAAA;AA/BF;;AAiCA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBCnQa;EDoQb,QAAA;EACA,YAAA;EACA,2EAAA;AA9BF;;AAgCA;EACE;IAKE,iCACE;EAlCJ;EAqCA;IACE,iCACE;EApCJ;EAuCA;IACE,iCACE;EAtCJ;AACF;AAyCA;EACE;IACE,4BAAA;EAvCF;AACF","sourcesContent":["@import '../../variables.scss';\n\n.chatLeft {\n  width: 350px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid $gray-border;\n  position: relative;\n\n  @media (max-width: 991.98px) {\n    width: 100%;\n  }\n\n  .btnInvite {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    margin: 0;\n    height: 54px;\n    width: 54px;\n    border-radius: 54px;\n    cursor: pointer;\n    right: 1.2rem;\n    bottom: 1.2rem;\n    z-index: 3;\n    background-color: $active-color;\n    transition: all 0.25s;\n    border: 3px solid white;\n\n    svg {\n      height: 24px;\n      width: 24px;\n      color: white;\n    }\n\n    &:hover {\n      border: 3px solid $sender-message-color;\n    }\n  }\n\n  &.chatLeftHide {\n    // width: 100%;\n    @media (max-width: 991.98px) {\n      visibility: hidden;\n      transform: translateX(-100%);\n    }\n  }\n}\n\n.headerContacts {\n  display: flex;\n  flex-direction: column;\n  padding: 0 16px;\n  padding-top: 18px;\n  gap: 8px;\n  text-align: start;\n\n  .titleHeader {\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 700;\n    color: $text-color-800;\n  }\n\n  .wrapperTabs {\n    width: 100%;\n    display: inline-flex;\n    flex-direction: row;\n\n    .tabItem {\n      font-size: 14px;\n      line-height: 20px;\n      font-weight: 400;\n      width: 50%;\n      display: inline-flex;\n      justify-content: center;\n      align-items: center;\n      padding: 8px 0;\n      cursor: pointer;\n      border-bottom: 2px solid $gray-box-border;\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      .unreadCount {\n        margin-inline-start: 5px;\n        transition: background-color 0.2s ease-in-out;\n        border-radius: 16px;\n        color: $white;\n        background-color: $active-color;\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 20px;\n        padding: 0 7px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        max-width: 22px;\n      }\n\n      &.active {\n        color: $active-color;\n        cursor: pointer;\n        border-bottom: 2px solid $active-color;\n      }\n    }\n  }\n}\n\n// .chatLeftHide {\n//   // width: 100%;\n//   @media (max-width: 991.98px) {\n//     visibility: hidden;\n//     transform: translateX(-100%);\n//   }\n// }\n\n.msg-new-tab {\n  font-size: medium;\n  font-weight: 500;\n  width: 50%;\n  display: inline-flex;\n  justify-content: center;\n  cursor: pointer;\n  padding-bottom: 4px;\n\n  border-radius: 15px;\n  padding-top: 5px;\n  background: $white;\n  color: $black;\n}\n\n.msg-withdraw-tab {\n  border-radius: 15px;\n  padding-top: 5px;\n  background: $white;\n  color: $black;\n\n  font-size: medium;\n  font-weight: 500;\n  width: 50%;\n  display: inline-flex;\n  justify-content: center;\n  cursor: pointer;\n  padding-bottom: 4px;\n}\n\n.msg-tab-active {\n  font-size: medium;\n  font-weight: 500;\n  width: 50%;\n  display: inline-flex;\n  justify-content: center;\n  cursor: pointer;\n  padding-bottom: 4px;\n  background-color: lightgray;\n  color: $black;\n}\n\n.msg-tabs-cont {\n  width: 100%;\n  display: inline-flex;\n  flex-direction: row;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  padding-left: 3px;\n  padding-right: 3px;\n}\n\n.btnClose {\n  background: transparent;\n  border: none;\n  padding: 0;\n\n  svg {\n    fill: $text-color-600;\n  }\n}\n\n.modalDialog {\n  width: 328px;\n\n  @media (max-width: 576px) {\n    width: auto;\n  }\n\n  .modalHeader {\n    justify-content: space-between;\n    border: none;\n  }\n\n  .modalBody {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 0 16px;\n\n    .inputBox {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n\n      .headerInput {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        justify-content: space-between;\n\n        span {\n          font-size: 14px;\n          line-height: 18px;\n          color: $text-color-800;\n        }\n\n        .counter {\n          font-size: 12px;\n          color: #495057;\n        }\n      }\n\n      .error {\n        color: #ec205f;\n        font-size: 12px;\n      }\n    }\n  }\n\n  .modalFooter {\n    border: none;\n\n    .dlgBtns {\n      width: 100%;\n      display: flex;\n      gap: 16px;\n\n      button {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.boxLoader {\n  padding-top: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loader {\n  width: 88px;\n  height: 12px;\n  background: radial-gradient(circle 5px at 5px center, $active-color 100%, transparent 0),\n    radial-gradient(circle 5px at 5px center, $active-color 100%, transparent 0);\n  background-size: 12px 12px;\n  background-repeat: no-repeat;\n  position: relative;\n  animation: ballX 1s linear infinite;\n}\n.loader:before {\n  content: '';\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: $active-color;\n  inset: 0;\n  margin: auto;\n  animation: moveX 1s cubic-bezier(0.5, 300, 0.5, -300) infinite;\n}\n@keyframes ballX {\n  0%,\n  25%,\n  50%,\n  75%,\n  100% {\n    background-position:\n      25% 0,\n      75% 0;\n  }\n  40% {\n    background-position:\n      25% 0,\n      85% 0;\n  }\n  90% {\n    background-position:\n      15% 0,\n      75% 0;\n  }\n}\n@keyframes moveX {\n  100% {\n    transform: translate(0.15px);\n  }\n}\n","$white: #ffffff;\n$black: #000000;\n\n$gray-background: #f5f5f7;\n$gray-border: #dce1e6;\n$gray-box-border: #e9e9eb;\n$gray-active: #eaedef;\n$active-color: #5f8fdf;\n$active-color-op: rgba(95, 143, 223, 0.4);\n// $active-color: #00ff95;\n$sender-message-color: #cce4ff;\n\n$text-color-800: #4a596a;\n$text-color-700: #626d7a;\n$text-color-600: #909399;\n\n$active-color-2: #ec205f;\n\n// $header-color: #add8e6;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatLeft": `style_chatLeft__3i6kB`,
	"btnInvite": `style_btnInvite__Z8Jnh`,
	"chatLeftHide": `style_chatLeftHide__hZtyQ`,
	"headerContacts": `style_headerContacts__cczrO`,
	"titleHeader": `style_titleHeader__yXO5n`,
	"wrapperTabs": `style_wrapperTabs__nMQhy`,
	"tabItem": `style_tabItem__zeqnp`,
	"unreadCount": `style_unreadCount__NhwlO`,
	"active": `style_active__ORA8B`,
	"msg-new-tab": `style_msg-new-tab__2pIVl`,
	"msg-withdraw-tab": `style_msg-withdraw-tab__hbFaP`,
	"msg-tab-active": `style_msg-tab-active__n6kF2`,
	"msg-tabs-cont": `style_msg-tabs-cont__w-2St`,
	"btnClose": `style_btnClose__W6JFD`,
	"modalDialog": `style_modalDialog__JNBfm`,
	"modalHeader": `style_modalHeader__HUca5`,
	"modalBody": `style_modalBody__2vIH0`,
	"inputBox": `style_inputBox__Lf+UU`,
	"headerInput": `style_headerInput__0tucd`,
	"counter": `style_counter__hXANB`,
	"error": `style_error__9bcnW`,
	"modalFooter": `style_modalFooter__b2nM5`,
	"dlgBtns": `style_dlgBtns__mM+KV`,
	"boxLoader": `style_boxLoader__ePIkg`,
	"loader": `style_loader__hk9yk`,
	"ballX": `style_ballX__ZsvzQ`,
	"moveX": `style_moveX__KWjbp`
};
export default ___CSS_LOADER_EXPORT___;
